<template>
  <div id="productH5Page" :class='addCartShow?"productH5Page2":""'>
		<Tabbar msg="/" />
		<plugin />
		<productAddCart :goods='goodsMsg'  @addCartShowFN="addCartShowFN"  v-if='addCartShow' />
		
		<!-- 悬浮窗 -->
	
			<div class='activeTypeBox'>
				<div class='activeType' :class='animationTypeIn?"activeType2":""'  @click='handleGoodsTypeList(100)'    >
					<img :src="activeType.img" />
				</div>
				<div class='activeTypeBoxMsk'></div>
			</div>
			
		
			<div class="app-top-border"></div>
		<!-- 立即定制 -->
		    <div class="productH5PageTop">
		        <div class="productH5PageTop-title">定制你的橘袋</div>
		        <div class="productH5PageTop-description">我们提供5大系列23款营养补剂，你可以自选配置你的方案。不会自选？没关系，来让我们的大数据系统为你配型定制。</div>
		        <div  class="app-btn app-btn--large app-btn--shadow"  style='letter-spacing:0.02rem;' @click='toQuestions'>即刻定制</div>
		    </div>
			
			
		<!-- 分类 -->
			<div class="itemstype">				
				<div class="itemtype" :class="item.active?'itemtypeactive':''" v-for='(item ,index) in goodsType'  @click='handleGoodsTypeList(item.id)'>
					<div class="itemtypeicon">
						<img :src='item.img' ></img>
					</div>
					<div class="itemtypename">{{item.title}}</div>
				</div>
			</div>
			  
			  
			  
			  
		<!-- 产品列表 -->
		
		<!-- 维生素 -->
		<div class="product-info" id='vitamin' v-if='goodsLabel1.length>0'>
			<div class="bgs">
				<img src="../assets/bg/vitamin-2.png"  class='productImg1' :class='vitaminShow?"productImg1active":""'/>
				<img src="../assets/bg/vitamin-3.png"  class='productImg3' :class='vitaminShow?"productImg3active":""' />
				<img src="../assets/bg/vitamin-1.png"  class='productImg4' :class='vitaminShow?"productImg4active":""'/>
			</div>
			<div class="title">维生素</div>
			<div class="product-info-content">
				<div>维生素是维持人体健康运转所需的基本营养成分。在人体的生长、代谢、发育过程发挥重要作用。采用发酵形式制成的维生素更有利于人体吸收和消化，是更类似天然成分的配方。</div>
			</div>
		</div>
		<!-- 维生素产品 -->
		<div class='productH5PageProductBox'>
			<div class='h5productBox' v-for='item in goodsLabel1'>
				<img :src="item.shrink_img" class='h5productImg' @click='goDetail' :data-id='item.id' style='cursor:pointer;' >
				<div class="h5productcontent">
					<div class="h5productname">{{item.goods_name}}</div>
					<div class="h5producttags">
					<img :src="img" v-for='img in item.cate_imgs'>
				</div>
			</div>   
			<div class="h5productprice" catchtap='null'>
				<div class="h5productprice1">每天{{item.day_use}}颗</div>
				<div class="h5productprice2" v-if='item.status==1&&item.isStockHave!=1' @click='openAddCart(item)' style='cursor:pointer;'>+</div>
				<div class="h5productprice2" v-if='item.status==1&&item.isStockHave==1'  style='font-size:0.2rem;color:rgba(155, 155, 155,0.8)'  >已售罄</div>
				<div class="h5productprice2" v-if='item.status==2'  @click='openAddCart(item)' style='cursor:pointer;'>+</div>
				<div class="h5productprice2" v-if='item.status==3'  style='font-size:0.2rem;color:rgba(155, 155, 155,0.8)'  >已售罄</div>
				</div>
			</div>
		</div>
		
		<!-- 矿物质 -->
		<div class="product-info" id='stone' v-if='goodsLabel2.length>0'>
			<div class="bgs">
				<img src="../assets/bg/mineral-1.png"  class='productImg4' :class='stoneShow?"productImg4active":""'/>
				<img src="../assets/bg/mineral-2.png"  class='productImg3' :class='stoneShow?"productImg3active":""' />
			</div>
			<div class="title">矿物质</div>
			<div class="product-info-content">
				<div>矿物质是人体所需七大营养素之一，但人体内不能自行合成。人体需要按照自身的不同需求最适量地摄入各种矿物质，我们在考虑安全剂量的同时，更注重选择安全吸收配方形式。</div>
			</div>
		</div>
		<!-- 矿物质产品 -->
		<div class='productH5PageProductBox'>
			<div class='h5productBox' v-for='item in goodsLabel2'>
				<img :src="item.shrink_img" class='h5productImg' @click='goDetail' :data-id='item.id' style='cursor:pointer;' >
				<div class="h5productcontent">
					<div class="h5productname">{{item.goods_name}}</div>
					<div class="h5producttags">
					<img :src="img" v-for='img in item.cate_imgs'>
				</div>
			</div>   
			<div class="h5productprice" catchtap='null'>
				<div class="h5productprice1">每天{{item.day_use}}颗</div>
				<div class="h5productprice2" v-if='item.status==1&&item.isStockHave!=1' @click='openAddCart(item)' style='cursor:pointer;'>+</div>
				<div class="h5productprice2" v-if='item.status==1&&item.isStockHave==1'  style='font-size:0.2rem;color:rgba(155, 155, 155,0.8)'  >已售罄</div>
				<div class="h5productprice2" v-if='item.status==2'  @click='openAddCart(item)' style='cursor:pointer;'>+</div>
				<div class="h5productprice2" v-if='item.status==3'  style='font-size:0.2rem;color:rgba(155, 155, 155,0.8)'  >已售罄</div>
				</div>
			</div>
		</div>
		
		<!-- 草本 -->
		<div class="product-info" id='herbaceous' v-if='goodsLabel3.length>0'>
			<div class="bgs">
				<img src="../assets/bg/herb-1.png"  class='productImg1' :class='herbaceousShow?"productImg1active":""'/>
				<img src="../assets/bg/herb-2.png"  class='productImg4' :class='herbaceousShow?"productImg4active":""' />
			</div>
			<div class="title">草本植物</div>
			<div class="product-info-content">
				<div>很多植物因其治疗作用被人类使用了几个世纪之久。草本补剂是由天然植物经过萃取提纯得到的浓缩精华，我们从全球各地甄选，只选用安全高品质、非转基因的植物作为原材料。</div>
			</div>
		</div>
		<!-- 草本产品 -->
		<div class='productH5PageProductBox'>
			<div class='h5productBox' v-for='item in goodsLabel3'>
				<img :src="item.shrink_img" class='h5productImg' @click='goDetail' :data-id='item.id' style='cursor:pointer;' >
				<div class="h5productcontent">
					<div class="h5productname">{{item.goods_name}}</div>
					<div class="h5producttags">
					<img :src="img" v-for='img in item.cate_imgs'>
				</div>
			</div>   
			<div class="h5productprice" catchtap='null'>
				<div class="h5productprice1">每天{{item.day_use}}颗</div>
				<div class="h5productprice2" v-if='item.status==1&&item.isStockHave!=1' @click='openAddCart(item)' style='cursor:pointer;'>+</div>
				<div class="h5productprice2" v-if='item.status==1&&item.isStockHave==1'  style='font-size:0.2rem;color:rgba(155, 155, 155,0.8)'  >已售罄</div>
				<div class="h5productprice2" v-if='item.status==2'  @click='openAddCart(item)' style='cursor:pointer;'>+</div>
				<div class="h5productprice2" v-if='item.status==3'  style='font-size:0.2rem;color:rgba(155, 155, 155,0.8)'  >已售罄</div>
				</div>
			</div>
		</div>
		
		<!-- 益生菌 -->
		<div class="product-info" id='probiotics' v-if='goodsLabel4.length>0'>
			<div class="bgs">
				<img src="../assets/bg/probiotic-1.png"  class='productImg4' :class='probioticsShow?"productImg4active":""'/>
				<img src="../assets/bg/probiotic-2.png"  class='productImg3' :class='probioticsShow?"productImg3active":""' />
			</div>
			<div class="title">益生菌</div>
			<div class="product-info-content">
				<div>益生菌是一种被证实的有益菌，对消化功能和免疫系统有着积极影响。我们用心精选了7联菌株，并加入有机益生元，帮助你的肠道维持最佳平衡状态</div>
			</div>
		</div>
		<!-- 益生菌产品 -->
		<div class='productH5PageProductBox'>
			<div class='h5productBox' v-for='item in goodsLabel4'>
				<img :src="item.shrink_img" class='h5productImg' @click='goDetail' :data-id='item.id' style='cursor:pointer;' >
				<div class="h5productcontent">
					<div class="h5productname">{{item.goods_name}}</div>
					<div class="h5producttags">
					<img :src="img" v-for='img in item.cate_imgs'>
				</div>
			</div>   
			<div class="h5productprice" catchtap='null'>
				<div class="h5productprice1">每天{{item.day_use}}颗</div>
				<div class="h5productprice2" v-if='item.status==1&&item.isStockHave!=1' @click='openAddCart(item)' style='cursor:pointer;'>+</div>
				<div class="h5productprice2" v-if='item.status==1&&item.isStockHave==1'  style='font-size:0.2rem;color:rgba(155, 155, 155,0.8)'  >已售罄</div>
				<div class="h5productprice2" v-if='item.status==2'  @click='openAddCart(item)' style='cursor:pointer;'>+</div>
				<div class="h5productprice2" v-if='item.status==3'  style='font-size:0.2rem;color:rgba(155, 155, 155,0.8)'  >已售罄</div>
				</div>
			</div>
		</div>
		
		<!-- 功能 -->
		<div class="product-info" id='special' v-if='goodsLabel5.length>0' >
			<div class="bgs">
				<img src="../assets/bg/special-1.png"  class='productImg1' :class='specialShow?"productImg1active":""'/>
				<img src="../assets/bg/special-2.png"  class='productImg2' :class='specialShow?"productImg2active":""' />
				<img src="../assets/bg/special-3.png"  class='productImg3' :class='specialShow?"productImg3active":""'/>
			</div>
			<div class="title">功能</div>
			<div class="product-info-content">
				<div>除基础营养补剂，我们针对特定人群的特殊需要研发了一系列功能性产品。如抗氧化、免疫调节、缓解体力疲劳、改善视力等健康需求功能。它们均来源于极佳的自然环境，严格的生产过程制成并通过功能性实验验证。</div>
			</div>
		</div>
		<!-- 功能产品 -->
		<div class='productH5PageProductBox'>
			<div class='h5productBox' v-for='item in goodsLabel5'>
				<img :src="item.shrink_img" class='h5productImg' @click='goDetail' :data-id='item.id' style='cursor:pointer;' >
				<div class="h5productcontent">
					<div class="h5productname">{{item.goods_name}}</div>
					<div class="h5producttags">
					<img :src="img" v-for='img in item.cate_imgs'>
				</div>
			</div>   
			<div class="h5productprice" catchtap='null'>
				<div class="h5productprice1">每天{{item.day_use}}颗</div>
				<div class="h5productprice2" v-if='item.status==1&&item.isStockHave!=1' @click='openAddCart(item)' style='cursor:pointer;'>+</div>
				<div class="h5productprice2" v-if='item.status==1&&item.isStockHave==1'  style='font-size:0.2rem;color:rgba(155, 155, 155,0.8)'  >已售罄</div>
				<div class="h5productprice2" v-if='item.status==2'  @click='openAddCart(item)' style='cursor:pointer;'>+</div>
				<div class="h5productprice2" v-if='item.status==3'  style='font-size:0.2rem;color:rgba(155, 155, 155,0.8)'  >已售罄</div>
				</div>
			</div>
		</div>

		
		
		
		<!-- 全部分类 -->
		<div class='moreTypeBox'  :class='moreType?"moreTypeBox2":""' v-if='moreType'>
		    <div class='moreTypeBoxTitle'>请选择分类</div>
		    <div class="itemstype">
		          <div class="itemtype"  v-for='item in allGoodsTypeList' :class="item.active?'itemtypeactive':''"  @click='handleGoodsTypeList(item.id)'  >
		              <div class="itemtypeicon">
		                  <img :src="item.img" />
		              </div>
		              <div class="itemtypename">{{item.title}}</div>
		          </div> 
		    </div>
		    <div class='closeMoreTypeBox' @click='closeMoreType'><img src="../assets/del-group.png"/></div>
		</div>
		
		



		<div style='height:2.1rem;'></div>
		
  </div>
</template>

<script>
import productAddCart from '@/components/productAddCart.vue'
import Tabbar from '@/components/tabbar.vue'
import plugin from '@/components/plugin.vue'
export default {
  name: 'productH5',
  components: {
	productAddCart,
	Tabbar,
	plugin
  },
  data:()=>{
    return{
		addCartShow:false,
        height:680,
        boxShow:false,
        showAllcate:false,
        activeNav:0,
        activeId:0,
        cateList:[],
		goodsType:[],
        productList:[],
        goodsLabel1:[],
        goodsLabel2:[],
        goodsLabel3:[],
        goodsLabel4:[],
        goodsLabel5:[],
		allGoodsTypeList:[],
		activeType:{
		          img: require('@/assets/bg/alltype.png'), active: true, title: "全部", id: 0
					},
		animationTypeIn:false,
		vitaminShow:false,
		stoneShow:false,
		herbaceousShow:false,
		probioticsShow:false,
		specialShow:false,
		moreType:false,
		clientHeight:1400,   //屏幕高
		firstScroll:true,
		vitaminHgith:10000,
		stoneHeight:10000,
		herbaceousHeight:10000,
		probioticsHeight:10000,
		specialHeight:10000,
		specialShow: false,
		vitaminShow: false,
		herbaceousShow: false,
		probioticsShow: false,
		stoneShow: false
    }
  },
  mounted () {
      window.addEventListener('scroll', this.scrollToTop,true)
  },
	 created:function(){
		 this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight;  
		 this.getGoodsTypeList()
		 this.getGoods(0)
		 window.scroll(0, 0);
	 },
 
  
  methods:{
	  // 定位图片
	    getRect: function(){
	      let that =this
		  // console.log(document.getElementById("#vitamin"))
		
		  // let _height = $("#vitamin").offset().top 
		  let _y = $('#vitamin')[0].offsetTop
		  console.log(_y)
		 

	      if (this.goodsLabel1) {
	         this.vitaminHgith = $('#vitamin')[0].offsetTop
	      }
	      if (this.goodsLabel2) {
	         this.stoneHeight = $('#stone')[0].offsetTop
	      }
	      if (this.goodsLabel3) {
	         this.herbaceousHeight = $('#herbaceous')[0].offsetTop
	      }
	      if (this.goodsLabel4) {
	         this.probioticsHeight = $('#probiotics')[0].offsetTop
	      }
	      if (this.goodsLabel5) {
	         this.specialHeight = $('#special')[0].offsetTop
	      }
	 
	          this.pecialShow = false
	          this.vitaminShow = false
	          this.herbaceousShow = false
	          this.probioticsShow = false
	          this.stoneShow = false
	
	
	      
	    },
	// 做问卷
	toQuestions(){
		this.$router.push({name: 'beforeQuestion'});
	},
	// 滚动
	scrollToTop(e) {
		
		
		if(this.firstScroll){
			this.getRect()
			this.firstScroll = false
		}
		let scrollTop = e.target.scrollTop
		let winH = this.clientHeight  // clientHeight  设备/屏幕高度
			
		// 悬浮窗
		if (scrollTop > winH  * 0.7){
			this.animationTypeIn = true
		}else{
			this.animationTypeIn = false
		}

		if (this.goodsLabel1.length>0){
			if ((scrollTop > this.vitaminHgith - 400) && !this.vitaminShow){
				this.vitaminShow = true
			}
		}
		if (this.goodsLabel2.length > 0) {
			if ((scrollTop > this.stoneHeight - 400) && !this.stoneShow) {
				this.stoneShow= true
			}
		}
		if (this.goodsLabel3.length > 0) {
			if ((scrollTop > this.herbaceousHeight - 400) && !this.herbaceousShow) {
				this.herbaceousShow= true
			}
		}
		if (this.goodsLabel4.length > 0) {
			if ((scrollTop > this.probioticsHeight - 400) && !this.probioticsShow) {
				this.probioticsShow= true
			}
		}
		if (this.goodsLabel5.length > 0) {
			if ((scrollTop > this.specialHeight - 400) && !this.specialShow) {
				this.specialShow=true
			}
		}
	          
	        },
	    // 获取导航
	getGoodsTypeList(){
		let that = this
		let _alltype = {
			img:require('@/assets/bg/alltype.png'), active: true,title:"全部",id:0,
		}
		let _moretype = {
			img:require('@/assets/bg/moretype.png'),active: false, title: "更多", id:100
		}
		this.axios({
		       method: 'post',
		       url:"category/index",
		       data:{}
		}).then(res=>{
			console.log(res)
			let _goodsType = []
			res.data.categorys.forEach((item) => {
				if (item.is_recommend == 1) {
					_goodsType.push(item)
				}
			})
			_goodsType.unshift(_alltype)
			_goodsType.push(_moretype)
			res.data.categorys.unshift(_alltype)
			  that.allGoodsTypeList=res.data.categorys
			  that.goodsType= _goodsType
		})
	      
	},
	// 获取商品
	getGoods(navid){
		let that = this
		this.axios({
		       method: 'post',
		       url:"goods/catGoods",
		       data:{
				   cid:navid
			   }
		}).then(res=>{
			that.productList = res.data.goodsList
			that.computeGoodsType()
			that.firstScroll = true
		})
	},
    // 商品分类
    computeGoodsType:function(){
      let _goodsList = this.productList
      let _goodsLabel1 = [],  //维生素
          _goodsLabel2 = [],  //矿物质
          _goodsLabel3 = [],  //草本
          _goodsLabel4 = [],  //益生菌
          _goodsLabel5 = [];  //特色产品
		this.goodsLabel1 =[]
		this.goodsLabel2 =[]
		this.goodsLabel3 = []
		this.goodsLabel4 = []
		this.goodsLabel5 = []
      _goodsList.forEach((item)=>{
        if (item.label == 1){
          _goodsLabel1.push(item)
        } else if (item.label == 2){
          _goodsLabel2.push(item)
        } else if (item.label == 3) {
          _goodsLabel3.push(item)
        } else if (item.label == 4) {
          _goodsLabel4.push(item)
        } else if (item.label == 5) {
          _goodsLabel5.push(item)
        }
      })
	  console.log(_goodsList)
      this.goodsLabel1 = _goodsLabel1
      this.goodsLabel2 = _goodsLabel2
      this.goodsLabel3 = _goodsLabel3
      this.goodsLabel4 = _goodsLabel4
      this.goodsLabel5 = _goodsLabel5
    },
    showAllNav(){
      this.showAllcate = !this.showAllcate
    
    },
    //所有分类
    handleAllNav(e){
      let _cateList = this.cateList
      let _navid = 0
      let _cateAction = require('@/assets/bg/alltype.png')
      _cateList.forEach((item)=>{
          if(item.id == e.target.dataset.navid){
            _cateAction = item.img
            _navid = item.id
          }
      })
		
      let that = this
      this.axios({
              method: 'post',
              url: 'goods/catGoods',
              data: {
                cid:_navid
              }
            }).then(res=>{
              console.log(res.data)
              that.productList = res.data.goodsList
              that.computeGoodsType()
              that.cateAction = _cateAction
              that.showAllcate = false
            })


    },
    // 点击导航
    handleNav(e){

      this.activeNav = e.target.dataset.nav||0
      let _scrollbox =48
      if(this.activeNav==1){
        _scrollbox =$(".vitamins").offset().top
      }else if(this.activeNav==2){
        _scrollbox =$(".minerals").offset().top
      }else if(this.activeNav==3){
        _scrollbox =$(".herbs").offset().top
      }else if(this.activeNav==4){
        _scrollbox =$(".probiotic").offset().top
      }else if(this.activeNav==5){
        _scrollbox =$(".profession").offset().top
      }
      $("html,body").animate({scrollTop:_scrollbox -48+ "px"}, 500);
    },
	
	// 点击导航搜索商品
	handleGoodsTypeList(typeid){
		
			if (typeid == 100) {
		        this.moreType= true
		      return
		    }
		    // this.setData({
		    //   firstload: false
		    // })
		    let _goodsTypeList = this.goodsType
		    let _allGoodsTypeList = this.allGoodsTypeList
		    let _activeId = 0
		    let _activeType = {}
		
		    _goodsTypeList.forEach((item)=>{
		      item.active=false
		      if (item.id == typeid){
		        item.active = true
		        _activeId = typeid
		        _activeType = item
		      }
		    })
		    _allGoodsTypeList.forEach((item) => {
		      item.active = false
		      if (item.id == typeid) {
		        item.active = true
		        _activeId = typeid
		        _activeType = item
		      }
		    })
		    
		
		      this.goodsType= _goodsTypeList
		      this.allGoodsTypeList=_allGoodsTypeList
		      this.activeId= _activeId
		      this.moreType= false
		      this.activeType= _activeType
		
		    this.getCatGoods()
	},
	// 关闭所有导航展示
	closeMoreType(){
		 this.moreType= false
	},
	// 分类查询
	getCatGoods(){
	    let that = this
	this.axios({
	        method: 'post',
	        url: 'goods/catGoods',
	        data: {
	          cid: this.activeId
	        }
	      }).then(res=>{
		   that.productList = res.data.goodsList
		   that.computeGoodsType()
	    })
	    
	},
	  
	
	goDetail(e){
		console.log("点击",e.target.dataset.id)
		this.$router.push({
			name:"productH5Detail",
			query:{id:e.target.dataset.id},
		})
	},
	// 打开加入橘袋组件
	openAddCart(eve){
		console.log(eve)
		this.goodsMsg = eve
		this.addCartShow = true
	},
	// 关闭加入橘袋组件
	addCartShowFN(){
		this.addCartShow = false
	},
  },

}
</script>
<style>
#productH5Page{
  background:rgba(255,255,255,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
  overflow-y:auto;
  font-family: "Microsoft YaHei";
}
#productH5Page::-webkit-scrollbar {display:none}
.productH5Page2{
		overflow-y: hidden !important;
}
.productH5PageTop{
	padding: 1rem 0.98rem 1.2rem 0.98rem;
}
.productH5PageTop-title{
	font-weight: bold;
	font-size: 0.56rem;
	line-height: 0.83rem;

}
.productH5PageTop-description{
	color: #505050;
	padding: 0.5rem 0;
	line-height: 0.44rem;

}
.itemstype{
    height: 3.6rem;
    display: flex;
    flex-wrap: wrap;
}
.itemtype{
    width: 1.5rem;
    height: 1.5rem;
    box-sizing: border-box;
    border:0.03rem solid rgba(224, 227, 222, 1);
    border-radius: 0.11rem;
    margin-left:0.3rem;
    margin-bottom:0.3rem;
	cursor:pointer;
}
.itemtypeicon{
  width:0.64rem;
  height:0.64rem;
  margin:0.3rem auto 0;
}
.itemtypename{
  font-size: 0.22rem;
  color: rgba(51, 51, 51, 1);
  width: 1.5rem;
  height:0.6rem;
  line-height:0.6rem;
  text-align: center;
}
.itemtype img{
    width:0.64rem;
    height:0.64rem;
}
.itemtypeactive{
  background-color: rgba(224, 227, 222, 1);
}
.moreTypeBox{
  position: fixed;
  top:0;
  width: 7.5rem;
  height: 100vh;
  z-index: 101;
  background-color: #fff;
  left: 50%;
  transform: translate( -50%, 0);  
}
.moreTypeBox2{
  right:-7.5rem;
}
.moreTypeBoxTitle{
  height: 1.13rem;
  margin-left:0.3rem;
  line-height: 1.13rem;
  border-top: 0.02rem solid rgba(244, 242, 240, 1);
  text-align: left;
}
.closeMoreTypeBox{
  height:0.42rem;
  width:0.42rem;
  padding: 0.5rem;
  position: absolute;
  bottom: 1.72rem;
  left: 3.04rem;
  overflow: hidden;
  box-sizing: content-box;
  cursor:pointer;
}
.closeMoreTypeBox img{
  height:0.42rem;
  width:0.42rem;
}

.activeTypeBox{
	height:1.4rem;
	width:7.5rem;
	position: fixed;
	z-index: 10;
	top:0.47rem;
	
	left: 50%;
	transform: translate( 50%, 0);  
	/* border: 1px solid rgba(153, 153, 153, 0.6); */
}
.activeTypeBoxMsk{
	background-color: #EAEAEA;
	height:1.4rem;
	width:7.5rem;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 12;
}
.activeType{
  height:1.14rem;
  width:1.14rem;
  background-color: #fff;
  position: absolute;
  overflow: hidden;
  top:0.05rem;
  left:0;
  border-radius:1.14rem;
  box-shadow: 0px 5px 10px rgba(153, 153, 153, 0.4);
  transition: all .6s;
  z-index: 11;
}
.activeType2{
  left:-1.4rem;
}
.activeType img{
  margin:0.3rem;
  height: 0.57rem;
  width: 0.57rem;
  display: block;
}

.product-info {
    margin: 0.8rem 0 0.8rem 0;
    position: relative;
    overflow: hidden;
}
.product-info .title {
    text-align: center;
    font-size: 0.48rem;
    font-weight: bold;
    padding: 1rem 0;
    line-height: 0.67rem;
}
.product-info .product-info-content {
    font-size: 0.32rem;
    color: #141414;
    margin: 0 0.9rem;
    line-height: 0.56rem;
    z-index: 9;
}
.product-info .product-info-content div {
    margin-bottom: 0.3rem;
}
.product-info .bgs img {
    position: absolute;
    z-index: 1;
}

.dong{
  transform:rotate(7deg);
}
/* 商品 */
.productH5PageProductBox{
  display: flex;
  flex-wrap: wrap;
  width: 7rem;
  margin-left: 0.5rem;
  position: relative;
  z-index: 9;
}

.product {
    background: #fff;
    box-sizing: border-box;
    margin-bottom: 0.32rem;
    margin-right: 0.28rem;
    border-radius: 0.05rem;
    box-shadow:-0.02rem 0.06rem 0.25rem 0.02rem rgba(213,215,212,0.4);
    width: 3.12rem;
    height: 4.46rem;
    font-family: "PingFang SC Light" , "Microsoft YaHei";
	/* font-family: "Microsoft Yahei"; */
    overflow: hidden;
}
.h5productBox {
    background: #fff;
    box-sizing: border-box;
	margin:0 0.28rem 0.32rem 0;
    border-radius: 0.05rem;
    box-shadow:-0.02rem 0.06rem 0.25rem 0.02rem rgba(213,215,212,0.4);
    width: 3.12rem;
    height: 4.64rem;
    font-family: "PingFang SC Light";
    overflow: hidden;
}
.h5productImg {
    width: 3.12rem;
    height: 2.32rem;
    overflow: hidden;
}

 .h5productcontent {
    width:2.72rem;
    height: 1.55rem;
    margin-left: 0.2rem;
    border-bottom: 0.02rem solid rgba(155, 155, 155, 0.1);
    overflow: hidden;
    
}
.h5productname{
    font-weight: bold;
    font-size:0.32rem;
    line-height: 0.45rem;
    width:2.72rem;
    height: 0.45rem;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0.31rem 0 0.12rem;
    color: rgba(20, 20, 20, 1);
    font-family: "PingFang SC Light";
	text-align: left;
}
.h5producttags {
    width:2.72rem;
    height:0.32rem;
    display: flex;
    align-items: center;
}
.h5producttags img {
    width:0.32rem;
    height:0.32rem;
    margin-right: 0.12rem;
}
.bgsTxt{
  font-size:0.32rem;
  color: rgba(20, 20, 20, 1);
}
.product .speciality {
    margin-top:0.3rem;
    border-bottom: 0.02rem solid #EDE7DE;
    padding: 0.2rem 0.1rem 0.29rem 0.1rem;
    color: #999999;
	text-align: left;
}
.product .speciality div {
    padding-left:0.4rem;
    position: relative;
    line-height: 0.48rem;
}
.product .speciality div:before {
    position: absolute;
    content: "";
    width: 0.12rem;
    height: 0.12rem;
    border-radius: 100%;
    left: 0;
    top: 45%;
    background: #727171;
}
.h5productprice {
    width: 2.72rem;
    height:0.8rem;
    line-height:0.8rem;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    margin-left: 0.2rem;
    font-size: 0.24rem;
    color: rgba(20, 20, 20, 1);
	text-align: left;
}
.h5productprice2{
  width: 1rem;
  font-size:0.38rem;
  font-weight: 400;
  text-align: right;
  padding-right: 0.2rem;
  text-align: right;
}


.productImg1{
    width:2.12rem;
    height:1.49rem;
    transition: all .6s;
    top: 1rem;
    left: -2.12rem;
}
.productImg1active{
    left: -0.8rem;
}
.productImg2{
    width:2.22rem;
    height:2.22rem;
    transition: all .6s;
    top:1rem;
    right: -2.22rem;
}
.productImg2active{
    right: -0.8rem;
}
.productImg3{
    width: 1.82rem;
    height: 1.82rem;
    transition: all .6s;
    left: -1.82rem;
    bottom: 0;
}
.productImg3active{
    left: -1rem;
}
.productImg4{
    width: 2.02rem;
    height: 2.02rem;
    transition: all .6s;
    right: -2.02rem;
    bottom: 2.2rem;
}
.productImg4active{
     right: -1rem;
}
.herbImg1{
  width: 3rem;
  height: 3rem;
  transition: all .9s;
  left: -3rem;
  top: 0.2rem
}
.herbImg1active{
  left: -1rem;
}
.herbImg2{
  width: 3rem;
  height: 3rem;
  transition: all .9s;
  right: -3rem;
  bottom: -0.5rem;
}
.herbImg2active{
 right: -2rem;
}
</style>